import axios from "axios";

let serviceBaseUrl = "";

process.env.NODE_ENV === "production"
  ? ['test.rayneo.cn'].includes(window.location.hostname) ? (serviceBaseUrl = "https://tdp-t.api.leiniao.com") : (serviceBaseUrl = "https://tdp-o.api.leiniao.com")
  : (serviceBaseUrl = "/tdpTApi");
const service = axios.create({
  // withCredentials: true, // send cookies when cross-domain requests
  baseURL: serviceBaseUrl, // url = base url + request url
  timeout: 5000, // request timeout
});
export default service;